import React from "react"
import Loader from "../Loader/index.js"
const Button = ({
  title,
  children,
  onClick,
  variant = "primary",
  className = "",
  isLoading,
  rightIcon,
  disabled,
  containerStyle
}) => {
  const buttonVariant = {
    primary: "bg-primary text-white font-[700] font-Apparat",
    secondary:
      "bg-white text-greyText font-[400] shadow-lg",
    tertiary: "bg-transparent text-primary font-[700]",
    quaternary: "font-Apparat text-white bg-[#424952] font-[600] shadow-lg"
  }
  return (
    <div className={containerStyle}>
      <button
        onClick={onClick}
        disabled={isLoading || disabled}
        className={`${buttonVariant[variant]} text-nowrap text-[14px] md:text-[16px] py-[6px] md:py-[12px] px-[24px]   lg:px-[40px] rounded-[90px] md:rounded-[25px] leading-[24px]  ${className} ${disabled ? "opacity-50" : ""}`}
      >
        {isLoading ? <Loader /> : title ? <span className="flex">
          {title}
          {rightIcon && <img src={rightIcon} className="w-[18px] h-[18px] ml-[5px]" />}
        </span> : children}
      </button>
    </div>
  )
}

export { Button }
